import { Link } from 'react-router-dom';

import PopperContainer from '../Popper/Popper';
import Tooltip from '../Tooltip/Tooltip';

const MakeLink = ({
  className,
  isLink,
  disabled,
  title,
  tooltipTrigger,
  tooltipHoverable,
  tooltipPlacement,
  tooltipOffsetX,
  tooltipOffsetY = 10,
  tooltipMaxWidth,
  tooltipActions,
  children,
}: $TSFixMe) => (
  <PopperContainer
    className=""
    trigger={tooltipTrigger}
    hoverable={tooltipHoverable}
    placement={tooltipPlacement}
    independentSize
    offsetY={tooltipOffsetY}
    offsetX={tooltipOffsetX}
  >
    {isLink &&
      (isLink.external ? (
        <a
          reference="true"
          className={`button-link ${className}`}
          rel="noreferrer"
          target="_blank"
          href={isLink.href}
          {...isLink}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();
            }
          }}
        >
          {children}
        </a>
      ) : (
        <Link
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: any; reference: string; classNam... Remove this comment to see the full error message
          reference="true"
          className={`button-link ${className}`}
          to={isLink.href}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();
            }
          }}
        >
          {children}
        </Link>
      ))}
    {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
    {!isLink && children}

    {/* @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: any; popper: string; }' is not a... Remove this comment to see the full error message */}
    <div popper="true">{title && <Tooltip title={title} tooltipMaxWidth={tooltipMaxWidth} actions={tooltipActions} />}</div>
  </PopperContainer>
);

export default MakeLink;
